import { useNavigate } from 'react-router';
import { useSortValueFromUrl } from 'idsk-react-components';
import getFilterString from './getFilterString';
import useDynamicState from '../../hooks/useDynamicState';

type ReturnType = {
  searchText: string | undefined;
  setSearchText: (nazov: string) => void;
  resetFilterHandler: () => void;
  targetUrl: string;
};

export default (
  page: number,
  perPage: number,
  filter: string,
  routeList: string,
):
  ReturnType => {
  const [searchText, setSearchText] = useDynamicState(filter);
  const { sort } = useSortValueFromUrl();
  const {
    targetUrl,
  } = getFilterString(
    routeList,
    page,
    perPage,
    sort,
    searchText,
  );
  const navigate = useNavigate();

  const resetFilterHandler = (): void => {
    setSearchText('');
    const {
      targetUrl: url,
    } = getFilterString(
      routeList,
      page,
      perPage,
      sort,
      '',
    );
    navigate(url);
  };

  return {
    searchText,
    setSearchText,
    resetFilterHandler,
    targetUrl,
  };
};
